var _style, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path15, _path16, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle12, _path17, _path18, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _circle13, _path19, _path20, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _circle14, _path21, _path22, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _circle15, _path23, _path24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _circle16, _path25, _path26, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _circle17, _polygon, _path27, _path28, _path29, _path30, _polygon2, _path31, _path32, _path33, _path34, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 888 485.5",
    style: {
      enableBackground: "new 0 0 888 485.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE5DB;}\n\t.st1{opacity:0.2;enable-background:new    ;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#FF6584;}\n\t.st4{fill:#E6E6E6;}\n\t.st5{fill:#F9A825;}\n\t.st6{fill:#00BF71;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 444.5,
    cy: 241.8,
    r: 241.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.5,418.2c-97.5,0-176.5-79-176.5-176.5s79-176.5,176.5-176.5S621,144.3,621,241.8 c0,46.8-18.6,91.7-51.7,124.8C536.3,399.7,491.3,418.3,444.5,418.2z M444.5,76.2c-91.3,0-165.6,74.3-165.6,165.6 c0,91.3,74.3,165.6,165.6,165.6c91.3,0,165.6-74.3,165.6-165.6C610.1,150.5,535.8,76.2,444.5,76.2L444.5,76.2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 444.5,
    cy: 241.8,
    r: 171
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.3,173.4c-5.5-10.7-1.2-23.7,9.5-29.2c10.7-5.5,23.7-1.2,29.2,9.5c0,0,0,0,0,0l48.3,94.9 c5.5,10.7,1.2,23.7-9.4,29.2c-10.7,5.5-23.7,1.2-29.2-9.4c0,0,0,0,0-0.1L317.3,173.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.7,184l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C345.7,167.5,332.4,173.6,322.7,184z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.1,204.4l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C356.1,188,342.8,194,333.1,204.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.5,224.8l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C366.5,208.4,353.2,214.4,343.5,224.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.9,245.3l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C376.9,228.8,363.6,234.9,353.9,245.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.3,265.7l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C387.3,249.3,374,255.3,364.3,265.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.1,208.9c-5.4-10.7-1.2-23.7,9.5-29.2c10.7-5.4,23.7-1.2,29.2,9.5c0,0,0,0,0,0l48.3,94.9 c5.4,10.7,1.2,23.8-9.5,29.2c-10.7,5.4-23.7,1.2-29.2-9.5L281.1,208.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.5,219.5l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C309.5,203,296.1,209.1,286.5,219.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.9,239.9l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C319.9,223.5,306.5,229.5,296.9,239.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.3,260.3l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C330.3,243.9,317,250,307.3,260.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.7,280.8l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C340.7,264.3,327.4,270.4,317.7,280.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.1,301.2l-2.2-4.4c11.1-8.6,24.2-15,38.7-19.7l2.2,4.4C351.1,284.8,337.8,290.8,328.1,301.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M558.8,247.2l0.2,0c10.7,0.1,20.3-6.4,24.2-16.2c4-10.1,6-20.8,5.9-31.7c-0.3-45.9-37.6-83.6-83.5-84.2 c-46.8-0.7-85.3,36.8-85.9,83.5c-0.5,34,19.5,65.1,50.6,78.8c9.7,4.3,21,2.2,28.5-5.3C514.7,256.1,536.3,247.2,558.8,247.2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 515.2,
    cy: 193.6,
    r: 28
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 454.4,
    cy: 187.1,
    r: 3.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 345.6,
    cy: 190.2,
    r: 3.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 472,
    cy: 152.9,
    r: 3.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 471.9,
    cy: 248,
    r: 3.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 537.2,
    cy: 146.1,
    r: 3.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 324.2,
    cy: 236.3,
    r: 3.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 348.3,
    cy: 283.7,
    r: 3.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 499.7,
    cy: 289.9,
    r: 12.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509,290.7c0,5.2-4.2,9.3-9.3,9.3c-5.1,0-9.3-4.2-9.3-9.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.4,289.2c0-5.2,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 495,
    cy: 285.7,
    rx: 0.8,
    ry: 1.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 499.7,
    cy: 284.1,
    rx: 0.8,
    ry: 1.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 499.7,
    cy: 294.2,
    rx: 0.8,
    ry: 1.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 504.4,
    cy: 288,
    rx: 0.8,
    ry: 1.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 503.6,
    cy: 296.6,
    rx: 0.8,
    ry: 1.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 494.3,
    cy: 292.7,
    rx: 0.8,
    ry: 1.2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 524.6,
    cy: 256.5,
    r: 12.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.9,257.3c0,5.2-4.2,9.3-9.3,9.3c-5.1,0-9.3-4.2-9.3-9.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.2,255.7c0-5.2,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 519.9,
    cy: 252.2,
    rx: 0.8,
    ry: 1.2
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 524.6,
    cy: 250.7,
    rx: 0.8,
    ry: 1.2
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 524.6,
    cy: 260.8,
    rx: 0.8,
    ry: 1.2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 529.2,
    cy: 254.6,
    rx: 0.8,
    ry: 1.2
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 528.5,
    cy: 263.1,
    rx: 0.8,
    ry: 1.2
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 519.1,
    cy: 259.2,
    rx: 0.8,
    ry: 1.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 549.4,
    cy: 273.6,
    r: 12.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,274.4c0,5.2-4.2,9.3-9.3,9.3c-5.1,0-9.3-4.2-9.3-9.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.1,272.8c0-5.2,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 544.8,
    cy: 269.3,
    rx: 0.8,
    ry: 1.2
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 549.4,
    cy: 267.8,
    rx: 0.8,
    ry: 1.2
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 549.4,
    cy: 277.9,
    rx: 0.8,
    ry: 1.2
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 554.1,
    cy: 271.7,
    rx: 0.8,
    ry: 1.2
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 553.3,
    cy: 280.2,
    rx: 0.8,
    ry: 1.2
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 544,
    cy: 276.3,
    rx: 0.8,
    ry: 1.2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 487.3,
    cy: 275.2,
    r: 12.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M496.6,276c0,5.2-4.2,9.3-9.3,9.3c-5.1,0-9.3-4.2-9.3-9.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477.9,274.4c0-5.2,4.2-9.3,9.3-9.3c5.1,0,9.3,4.2,9.3,9.3"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 482.6,
    cy: 270.9,
    rx: 0.8,
    ry: 1.2
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 487.3,
    cy: 269.3,
    rx: 0.8,
    ry: 1.2
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 487.3,
    cy: 279.5,
    rx: 0.8,
    ry: 1.2
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 491.9,
    cy: 273.2,
    rx: 0.8,
    ry: 1.2
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 491.1,
    cy: 281.8,
    rx: 0.8,
    ry: 1.2
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 481.8,
    cy: 277.9,
    rx: 0.8,
    ry: 1.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 515.2,
    cy: 280.6,
    r: 12.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.6,281.4c0,5.2-4.2,9.3-9.3,9.3c-5.2,0-9.3-4.2-9.3-9.3c0,0,0,0,0,0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.9,279.8c0-5.2,4.2-9.3,9.3-9.3c5.2,0,9.3,4.2,9.3,9.3c0,0,0,0,0,0"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 510.6,
    cy: 276.3,
    rx: 0.8,
    ry: 1.2
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 515.2,
    cy: 274.8,
    rx: 0.8,
    ry: 1.2
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 515.2,
    cy: 284.9,
    rx: 0.8,
    ry: 1.2
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 519.9,
    cy: 278.7,
    rx: 0.8,
    ry: 1.2
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 519.1,
    cy: 287.2,
    rx: 0.8,
    ry: 1.2
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 509.8,
    cy: 283.3,
    rx: 0.8,
    ry: 1.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 534.7,
    cy: 293.8,
    r: 12.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544,294.6c0,5.2-4.2,9.3-9.3,9.3s-9.3-4.2-9.3-9.3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.4,293.1c0-5.2,4.2-9.3,9.3-9.3s9.3,4.2,9.3,9.3l0,0"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 530,
    cy: 289.6,
    rx: 0.8,
    ry: 1.2
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 534.7,
    cy: 288,
    rx: 0.8,
    ry: 1.2
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 534.7,
    cy: 298.1,
    rx: 0.8,
    ry: 1.2
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 539.3,
    cy: 291.9,
    rx: 0.8,
    ry: 1.2
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 538.6,
    cy: 300.4,
    rx: 0.8,
    ry: 1.2
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 529.2,
    cy: 296.6,
    rx: 0.8,
    ry: 1.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 374.7,
    cy: 246.4,
    r: 3.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "464.3,366.1 385.2,344.1 388.2,332.9 467.4,354.8 "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M452.7,362.3c-27.1,5.2-55,5.2-82.1,0v-11.7c27.2,4.5,54.9,4.5,82.1,0V362.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M461.2,327.3c-27.1,5.2-55,5.2-82.1,0v-11.7c27.2,4.5,54.9,4.5,82.1,0L461.2,327.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M489.6,341.3c-27.1,5.2-55,5.2-82.1,0v-11.7c27.2,4.5,54.9,4.5,82.1,0V341.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M496.5,354.5c-27.1,5.2-55,5.2-82.1,0v-11.7c27.2,4.5,54.9,4.5,82.1,0V354.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "520.5,371.8 439.6,385.4 437.7,373.9 518.7,360.3 "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M508.4,373.3c-22.5,16.2-47.8,28-74.6,34.8l-4.8-10.6c26.6-7.4,51.8-19.2,74.6-34.8L508.4,373.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M501.7,337.9c-22.5,16.2-47.8,28-74.6,34.8l-4.8-10.6c26.6-7.4,51.8-19.2,74.6-34.8L501.7,337.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M533.2,338.6c-22.5,16.2-47.8,28-74.6,34.8l-4.8-10.6c26.6-7.4,51.8-19.2,74.6-34.8L533.2,338.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M545,347.7c-22.5,16.2-47.8,28-74.6,34.8l-4.8-10.6c26.6-7.4,51.8-19.2,74.6-34.8L545,347.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 324.9,
    className: "st6",
    width: 3.9,
    height: 3.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 454.6,
    y: 392.6,
    className: "st6",
    width: 3.9,
    height: 3.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 392.4,
    y: 324.9,
    className: "st6",
    width: 3.9,
    height: 3.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 482.6,
    y: 373.1,
    className: "st6",
    width: 3.9,
    height: 3.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 484.9,
    y: 350.6,
    className: "st6",
    width: 3.9,
    height: 3.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 337,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -96.2214 497.8379)",
    className: "st6",
    width: 3.1,
    height: 5.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 465.9,
    y: 345.5,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -83.1836 539.5404)",
    className: "st6",
    width: 3.1,
    height: 5.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 409.9,
    y: 360.3,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -119.9511 499.7027)",
    className: "st6",
    width: 3.1,
    height: 5.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 440.6,
    y: 358.4,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -103.4007 524.7128)",
    className: "st6",
    width: 5.4,
    height: 3.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 461.6,
    y: 363.8,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -98.6991 544.4673)",
    className: "st6",
    width: 5.4,
    height: 3.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 517.6,
    y: 345.1,
    transform: "matrix(0.5614 -0.8275 0.8275 0.5614 -58.712 582.6049)",
    className: "st6",
    width: 5.4,
    height: 3.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.78ecb737d4d8c4fa674293d5da49a003.svg";
export { ForwardRef as ReactComponent };